module.exports = __webpack_public_path__ + "media/images/icon__nativeAppShare@3x-4aeba4d91c35623db1307b6ec183bec2.png";